import type { RuntimeMode } from './types';

/**
 * A wallet connection is an onboarding/signing tool, not a runtime gate.
 *
 * The trading-authority half is load-bearing well beyond trading, so do not
 * drop it without moving what depends on it first. `useOnboardingFlow` reads
 * `isRealMode` as "this user is fully onboarded" — "a partially onboarded user
 * (authorization wallet only) never reaches real mode" — and that is what lets
 * it read a `custodialWalletMissing` error as "no first deposit yet" rather
 * than "no wallet at all".
 *
 * Making every signed-in user real (2026-09-04, reverted the same day) broke
 * that invariant: a user with no custodial wallet was reported as having one,
 * `inWalletGate` and `needsProvisioning` both went false, and the wizard
 * bounced between onboarding and deposit. Demo-only-when-signed-out is still
 * the right end state; it needs the onboarding flow to get its own
 * "onboarded?" signal first.
 */
export function deriveRuntimeMode(
    hasValidAppToken: boolean,
    hasTradingAuthority: boolean,
): RuntimeMode {
    return hasValidAppToken && hasTradingAuthority ? 'real' : 'demo';
}
